// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { Res, setRes, TFunc, UI, uqStringify } from "tonva-react";
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { FieldItem, FieldItemInt, FieldItemNum, FieldItemString, FieldItemId } from "tonva-react";
import { CustomerWebsiteLeads } from "./JkCoupon";

/*--fields--*/
const fields = {
	id: {
		"name": "id",
		"type": "id",
		"isKey": false,
		"label": "Id"
	} as FieldItemId,
	salesman: {
		"name": "salesman",
		"type": "id",
		"isKey": false,
		"label": "Salesman"
	} as FieldItemId,
	lastVisited: {
		"name": "lastVisited",
		"isKey": false,
		"label": "LastVisited"
	} as undefined,
	timesVisited: {
		"name": "timesVisited",
		"type": "integer",
		"isKey": false,
		"widget": "updown",
		"label": "TimesVisited"
	} as FieldItemInt,
};
/*==fields==*/

const fieldArr: FieldItem[] = [
	fields.salesman, fields.lastVisited, fields.timesVisited, 
];

export const ui: UI = {
	label: "CustomerWebsiteLeads",
	fieldArr,
	fields,
};

const resRaw: Res<any> = {
	$zh: {
	},
	$en: {
	}
};
const res: any = {};
setRes(res, resRaw);

export const t:TFunc = (str:string|JSX.Element): string|JSX.Element => {
	return res[str as string] ?? str;
}

export function render(item: CustomerWebsiteLeads):JSX.Element {
	return <>{uqStringify(item)}</>;
};
